/** This slice is for data used commonly in nearly ever component of our application */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	data: {},
	hasPermission: false,
	isLoggedIn: false,
};

export const facebookApiSlice = createSlice({
	name: 'facebook',
	initialState: initialState,
	reducers: {
		setData: (state, action) => {
			state.data = action.payload;
		},
		setHasPermission: (state, action) => {
			state.hasPermission = action.payload;
		},
		setIsLoggedIn: (state, action) => {
			state.isLoggedIn = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setData, setHasPermission, setIsLoggedIn } =
	facebookApiSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectData = (state) => state.facebook.data;
export const selectHasPermission = (state) => state.facebook.hasPermission;
export const selectIsLoggedIn = (state) => state.facebook.isLoggedIn;

export default facebookApiSlice.reducer;
